import React from 'react'

import { ContributionSummary, ProductsList } from '@components/common'
import { ProductItemGroupedDetails } from '@components/common/ProductItemGroupedDetails/ProductItemGroupedDetails'
import { PriceString, Tag } from '@fourthwall/components'

import type { Order } from '../../Order.types'

type CancelledOffersProps = {
  cancelledOffers: Order['offersCancelled']
  cancellations: Order['cancellations']
}

export const CancelledOffers = ({ cancelledOffers, cancellations }: CancelledOffersProps) => {
  const cancellation = cancellations.at(-1)

  const renderOffer = ({
    variant,
    offer,
    quantity,
    price,
    grouped,
  }: Order['offersCancelled'][number]) => (
    <ProductsList.Item
      key={variant?.id}
      image={offer.thumbnailImage}
      offerId={offer?.id}
      name={offer?.name}
      variants={variant.attributesDescription}
      quantity={quantity}
      price={<PriceString value={price.value} />}
      details={grouped ? <ProductItemGroupedDetails groupedDetails={grouped} /> : undefined}
    />
  )

  const getTitle = () => {
    if (cancellation?.issuer === 'Supporter') {
      return 'Canceled by supporter'
    }

    if (cancellation?.issuer === 'Creator') {
      return 'Canceled by you'
    }

    return 'Canceled'
  }

  return (
    <ContributionSummary title={getTitle()} status={<Tag label="Canceled" appearance="alert" />}>
      <ContributionSummary.Section>
        <ProductsList size="large">{cancelledOffers.map(renderOffer)}</ProductsList>
      </ContributionSummary.Section>
    </ContributionSummary>
  )
}
